import React from 'react';
import './App.scss';
import Main from './components/Main';
import GameProvider from "./libs/GameProvider";
import AudioProvider from './libs/audio-provider';
import BackgroundProvider from './libs/BackgroundProvider';
import ImagePreloader from './libs/ImagePreloader';
import preval from 'preval.macro'

const dateTimeStamp = preval`module.exports = new Date().toISOString();`

function App() {
  ImagePreloader();

  console.log('Build date: ', dateTimeStamp, ' @ ', process.env.NODE_ENV);

  return (
    <div className="App">
      <GameProvider>
        <AudioProvider>
          <BackgroundProvider>
            <Main />
          </BackgroundProvider>
        </AudioProvider>
      </GameProvider>
    </div>
  );
}

export default App;
